export default {"src":"/_next/static/media/ai-lesson.de9609a8.svg","height":87,"width":123,"blurWidth":0,"blurHeight":0};